// i18nResources.ts
export const resources = {
  en: {
    translation: {
      AnnualMilage: 'Annual Mileage',
      Confirm: 'Confirm',
      Currency: '£',
      Downpayment: 'Downpayment',
      Duration: 'Duration',
      ErrorMessage: 'Something went wrong, please refresh the content.',
      Header: 'Rent your car with us',
      IncludedServices: 'Services Included',
      InitialRentals: 'Initial Rental',
      Loading: 'loading...',
      ManufacturerCodeIncorrectMsg:
        'Something went wrong, please check the manufacturer code.',
      OptionalServicesTitle: 'Optional Services',
      Pricing: '£/month',
      ProductName: 'Customize your product',
      PromoCode: 'Do you have a promo code?',
      PromoCodeLabel: 'Promo Code',
      ReloadButton: 'reload',
      Remove: 'Remove',
      ServicesSelected: 'Services selected',
      ShowLess: 'Show less services',
      ShowMore: 'Discover all services included',
      UnitMeasureKm: 'miles',
      UnitMeasureMonth: 'month',
      UnitMeasureMonths: 'months',
      VATexcl: 'VAT excl.',
      VATinc: 'VAT incl.',
      Validate: 'Validate',
      ValidationError: 'The promo code is not valid.'
    }
  },
  es: {
    translation: {
      AnnualMilage: 'Kilometraje anual',
      Confirm: 'Confirmar',
      Currency: '€',
      Downpayment: 'Entrada',
      Duration: 'Duración',
      ErrorMessage: 'Algo salió mal, por favor actualiza el contenido.',
      Header: 'Alquila tu coche con nosotros',
      IncludedServices: 'Servicios incluidos',
      Loading: 'cargando...',
      ManufacturerCodeIncorrectMsg:
        'Algo salió mal, por favor verifica el código del fabricante.',
      OptionalServicesTitle: 'Servicios opcionales',
      Pricing: '€/mes',
      ProductName: 'Personaliza tu alquiler',
      PromoCode: '¿Tienes un código promocional?',
      PromoCodeLabel: '¿Tienes un código promocional',
      ReloadButton: 'actualizar',
      Remove: 'Eliminar',
      ServicesSelected: 'Servicios seleccionados',
      ShowLess: 'Mostrar menos servicios',
      ShowMore: 'Descubre todos los servicios incluidos',
      UnitMeasureKm: 'km',
      UnitMeasureMonth: 'mes',
      UnitMeasureMonths: 'meses',
      VATexcl: 'IVA excl.',
      VATinc: 'IVA incl.',
      Validate: 'Validar',
      ValidationError: 'El código promocional no es válido.'
    }
  },
  fr: {
    translation: {
      AnnualMilage: 'Kilométrage annuel',
      Confirm: 'Confirmer',
      Currency: '€',
      Downpayment: 'Apport',
      Duration: 'Durée',
      ErrorMessage: `Quelque chose s'est mal passé, veuillez rafraîchir le contenu.`,
      Header: 'Louez votre voiture avec nous',
      IncludedServices: 'Services inclus',
      Loading: 'chargement...',
      ManufacturerCodeIncorrectMsg: `Quelque chose s'est mal passé, veuillez vérifier le code du constructeur.`,
      OptionalServicesTitle: 'Services optionnels',
      Pricing: '€/mois',
      ProductName: 'Personnalisez votre location',
      PromoCode: 'Avez-vous un code promo?',
      PromoCodeLabel: 'Avez-vous un code promo?',
      ReloadButton: 'actualiser',
      Remove: 'Supprimer',
      ServicesSelected: 'Services sélectionnés',
      ShowLess: 'Afficher moins de services',
      ShowMore: 'Découvrez tous les services inclus',
      UnitMeasureKm: 'km',
      UnitMeasureMonth: 'mois',
      UnitMeasureMonths: 'mois',
      VATexcl: 'HT',
      VATinc: 'TTC',
      Validate: 'Valider',
      ValidationError: "Le code promo n'est pas valide."
    }
  },
  it: {
    translation: {
      AnnualMilage: 'Chilometraggio annuo',
      Confirm: 'Conferma',
      Currency: '€',
      Downpayment: 'Anticipo',
      Duration: 'Durata',
      ErrorMessage:
        'Qualcosa è andato storto, per favore aggiorna il contenuto.',
      Header: 'Noleggia la tua auto con noi',
      IncludedServices: 'Servizi inclusi nel canone',
      Loading: 'caricamento...',
      ManufacturerCodeIncorrectMsg:
        'Qualcosa è andato storto, controlla il codice del produttore.',
      OptionalServicesTitle: 'Servizi opzionali',
      Pricing: '€/mese',
      ProductName: 'Personalizza il tuo prodotto',
      PromoCode: 'Hai un codice sconto?',
      PromoCodeLabel: 'Codice sconto',
      ReloadButton: 'aggiorna',
      Remove: 'Rimuovi',
      ServicesSelected: 'Servizi selezionati',
      ShowLess: 'Mostra meno servizi',
      ShowMore: 'Scopri tutti i servizi inclusi',
      UnitMeasureKm: 'km',
      UnitMeasureMonth: 'mesi',
      UnitMeasureMonths: 'mesi',
      VATexcl: 'IVA escl.',
      VATinc: 'IVA incl.',
      Validate: 'APPLICA',
      ValidationError: 'Il codice sconto non è valido.'
    }
  }
};
